define('OutSystems/ClientRuntime/DataTypes',["require", "exports", "tslib", "./Decimal", "./Exceptions", "./Flow", "./Format", "./LightImmutable", "./LongInteger", "./Settings"], function (require, exports, tslib_1, Decimal_1, Exceptions_1, Flow, Format_1, LightImmutable_1, LongInteger_1, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TypeValidations = exports.ComplexTypeKeyedTypeFactory = exports.BasicTypeKeyedTypeFactory = exports.TypeKeyedTypeFactory = exports.RecordTypeFactory = exports.ErrorHandlerOutputType = exports.JSONSerializeOutputType = exports.RecordWithStaticConstructor = exports.VariableHolder = exports.BasicVariableHolder = exports.TextList = exports.BinaryDataList = exports.BooleanList = exports.PhoneNumberList = exports.EmailList = exports.CurrencyList = exports.DecimalList = exports.TimeList = exports.DateTimeList = exports.DateList = exports.LongIntegerList = exports.IntegerList = exports.GenericRecordList = exports.BasicTypeList = exports.List = exports.GenericRecord = exports.Record = exports.ImmutableBase = exports.ImmutableListWithTracking = exports.defaultForType = exports.areBinaryNulls = exports.equals = exports.compare = exports.ListCache = exports.Cache = exports.Constants = exports.DateTime = exports.BinaryData = exports.LongInteger = exports.Decimal = exports.mapDataTypeToName = exports.DataTypes = void 0;
    exports.Decimal = Decimal_1.default;
    exports.LongInteger = LongInteger_1.default;
    var CACHE_SUFFIX = "__cache";
    function coalesce(a, b) {
        return a === null || a === undefined ? b : a;
    }
    var DataTypes;
    (function (DataTypes) {
        DataTypes[DataTypes["Integer"] = 0] = "Integer";
        DataTypes[DataTypes["LongInteger"] = 1] = "LongInteger";
        DataTypes[DataTypes["Decimal"] = 2] = "Decimal";
        DataTypes[DataTypes["Currency"] = 3] = "Currency";
        DataTypes[DataTypes["Text"] = 4] = "Text";
        DataTypes[DataTypes["PhoneNumber"] = 5] = "PhoneNumber";
        DataTypes[DataTypes["Email"] = 6] = "Email";
        DataTypes[DataTypes["Boolean"] = 7] = "Boolean";
        DataTypes[DataTypes["Date"] = 8] = "Date";
        DataTypes[DataTypes["DateTime"] = 9] = "DateTime";
        DataTypes[DataTypes["Time"] = 10] = "Time";
        DataTypes[DataTypes["Record"] = 11] = "Record";
        DataTypes[DataTypes["RecordList"] = 12] = "RecordList";
        DataTypes[DataTypes["BinaryData"] = 13] = "BinaryData";
        DataTypes[DataTypes["Object"] = 14] = "Object";
    })(DataTypes || (exports.DataTypes = DataTypes = {}));
    var mapDataTypeToName = function (type) {
        switch (type) {
            case DataTypes.Integer:
                return "Integer";
            case DataTypes.LongInteger:
                return "Long Integer";
            case DataTypes.Decimal:
                return "Decimal";
            case DataTypes.Currency:
                return "Currency";
            case DataTypes.Text:
                return "Text";
            case DataTypes.PhoneNumber:
                return "Phone Number";
            case DataTypes.Email:
                return "Email";
            case DataTypes.Boolean:
                return "Boolean";
            case DataTypes.Date:
                return "Date";
            case DataTypes.DateTime:
                return "Date Time";
            case DataTypes.Time:
                return "Time";
            case DataTypes.Record:
                return "Record";
            case DataTypes.RecordList:
                return "List";
            case DataTypes.BinaryData:
                return "Binary Data";
            case DataTypes.Object:
                return "Object";
            default:
                return "Unknown: ".concat(type);
        }
    };
    exports.mapDataTypeToName = mapDataTypeToName;
    var BinaryData = (function () {
        function BinaryData(content, _url, getOfflineContent) {
            var _this = this;
            this._url = _url;
            this.getOfflineContent = getOfflineContent;
            this._cachedBlob = null;
            if (typeof Blob !== "undefined" && content instanceof Blob) {
                this._cachedBlob = content;
                this.getOfflineContent = function () {
                    return _this._content ? Promise.resolve(_this._content) : BinaryData.blobToBase64(_this._cachedBlob);
                };
            }
            else {
                this._content = content || null;
            }
        }
        Object.defineProperty(BinaryData.prototype, "url", {
            get: function () {
                return this._url;
            },
            set: function (url) {
                this._url = url;
                this.clearCachedBlob();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BinaryData.prototype, "cachedBlob", {
            get: function () {
                return this._cachedBlob;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(BinaryData.prototype, "content", {
            get: function () {
                return this._content;
            },
            set: function (content) {
                this._content = content;
                this.clearCachedBlob();
            },
            enumerable: false,
            configurable: true
        });
        BinaryData.prototype.loadContent = function () {
            var _this = this;
            if (!this.getOfflineContent) {
                return Flow.executeSequence(function () { return _this; });
            }
            return this.getOfflineContent().then(function (content) {
                _this.content = content;
                return Promise.resolve(_this);
            });
        };
        BinaryData.prototype.hasContent = function () {
            return !!(this._url || this._content);
        };
        BinaryData.prototype.fastEquals = function (other) {
            return (other &&
                this.constructor === other.constructor &&
                this._url === other._url &&
                this._content === other._content &&
                ((!!this.getOfflineContent && !!other.getOfflineContent) ||
                    (!this.getOfflineContent && !other.getOfflineContent)));
        };
        BinaryData.prototype.base64toHex = function (base64String) {
            var decodedString = atob(base64String);
            var hexEncodedString = "";
            for (var i = 0; i < decodedString.length; i++) {
                var hex = decodedString.charCodeAt(i).toString(16);
                hexEncodedString += hex.length === 2 ? hex : "0" + hex;
            }
            return hexEncodedString;
        };
        BinaryData.prototype.getContentType = function () {
            if (this._content) {
                var hexEncodedFileHeader = this.base64toHex(this._content.substr(0, 16));
                if (hexEncodedFileHeader.substr(0, 8) === "00000100") {
                    return "image/x-icon";
                }
                if (hexEncodedFileHeader.substr(0, 8) === "ffd8ffdb" ||
                    hexEncodedFileHeader.substr(0, 8) === "ffd8ffe0" ||
                    hexEncodedFileHeader.substr(0, 8) === "ffd8ffe1") {
                    return "image/jpeg";
                }
                if (hexEncodedFileHeader.substr(0, 8) === "49492a00" || hexEncodedFileHeader.substr(0, 8) === "4d4d002a") {
                    return "image/tiff";
                }
                if (hexEncodedFileHeader.substr(0, 4) === "424d") {
                    return "image/bmp";
                }
                if (hexEncodedFileHeader.substr(0, 6) === "474946") {
                    return "image/gif";
                }
                if (hexEncodedFileHeader.substr(0, 8) === "89504e47") {
                    return "image/png";
                }
                return "application/octet-stream";
            }
            else {
                return null;
            }
        };
        BinaryData.prototype.toDataURI = function () {
            if (this._content) {
                return "data:".concat(this.getContentType(), ";base64,").concat(this._content);
            }
            else {
                return null;
            }
        };
        BinaryData.prototype.toBlob = function () {
            if (!this._cachedBlob && this._content) {
                this._cachedBlob = BinaryData.base64toBlob(this._content, this.getContentType());
            }
            return this._cachedBlob;
        };
        BinaryData.prototype.toArrayBuffer = function () {
            if (!this._content) {
                return null;
            }
            return BinaryData.base64ToArrayBuffer(this._content);
        };
        Object.defineProperty(BinaryData.prototype, "length", {
            get: function () {
                var blob = this.toBlob();
                return blob ? blob.size : 0;
            },
            enumerable: false,
            configurable: true
        });
        BinaryData.blobToBase64 = function (blob) {
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = function () {
                    var result = reader.result;
                    resolve(result.substring(result.indexOf(",") + 1));
                };
                reader.onerror = function () {
                    reject(reader.error);
                };
            });
        };
        BinaryData.base64toBlob = function (base64Data, contentType, sliceSize) {
            if (contentType === void 0) { contentType = ""; }
            if (sliceSize === void 0) { sliceSize = 512; }
            var byteCharacters = atob((base64Data || "").replace(/\s/g, ""));
            var byteArrays = [];
            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);
                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                var byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
            return new Blob(byteArrays, { type: contentType });
        };
        BinaryData.base64ToArrayBuffer = function (base64Data) {
            return Uint8Array.from(atob(base64Data), function (c) { return c.charCodeAt(0); }).buffer;
        };
        BinaryData.prototype.clearCachedBlob = function () {
            this._cachedBlob = null;
        };
        BinaryData.defaultValue = new BinaryData();
        return BinaryData;
    }());
    exports.BinaryData = BinaryData;
    var DEFAULT_YEAR = 1900;
    var DEFAULT_MONTH = 0;
    var DEFAULT_DAY = 1;
    var DEFAULT_HOURS = 0;
    var DEFAULT_MINUTES = 0;
    var DEFAULT_SECONDS = 0;
    var DEFAULT_MILLISECONDS = 0;
    var DEFAULT_WEEKDAY = 1;
    var DateTime = (function () {
        function DateTime(year, month, day, hours, minutes, seconds, milliseconds) {
            this.isDefaultDate = false;
            if (arguments.length === 0) {
                this.date = this.nativeDefaultDate();
            }
            else if (arguments.length === 1) {
                if (year instanceof Date || Object.prototype.toString.call(year) === "[object Date]") {
                    var nativeDateValue = year.getTime();
                    if (!isNaN(nativeDateValue)) {
                        this.date = new Date(nativeDateValue);
                    }
                    else {
                        this.date = this.nativeDefaultDate();
                    }
                }
                else {
                    this.date = new Date(year);
                }
            }
            else if (coalesce(year, DEFAULT_YEAR) < 100) {
                this.date = new Date(100, 0, 1, 0, 0, 0, 0);
                this.date.setFullYear(coalesce(year, DEFAULT_YEAR));
                this.date.setMonth(coalesce(month, DEFAULT_MONTH + 1) - 1);
                this.date.setDate(coalesce(day, DEFAULT_DAY));
                this.date.setHours(coalesce(hours, DEFAULT_HOURS));
                this.date.setMinutes(coalesce(minutes, DEFAULT_MINUTES));
                this.date.setSeconds(coalesce(seconds, DEFAULT_SECONDS));
                this.date.setMilliseconds(coalesce(milliseconds, DEFAULT_MILLISECONDS));
            }
            else {
                this.date = new Date(coalesce(year, DEFAULT_YEAR), coalesce(month, DEFAULT_MONTH + 1) - 1, coalesce(day, DEFAULT_DAY), coalesce(hours, DEFAULT_HOURS), coalesce(minutes, DEFAULT_MINUTES), coalesce(seconds, DEFAULT_SECONDS), coalesce(milliseconds, DEFAULT_MILLISECONDS));
            }
            this.isDefaultDate =
                !(0, Settings_1.getEnvParams)().NullDatesTZAware &&
                    this.date.getFullYear() === DEFAULT_YEAR &&
                    this.date.getMonth() === DEFAULT_MONTH &&
                    this.date.getDate() === DEFAULT_DAY &&
                    this.date.getHours() === DEFAULT_HOURS &&
                    this.date.getMinutes() === DEFAULT_MINUTES &&
                    this.date.getSeconds() === DEFAULT_SECONDS &&
                    this.date.getMilliseconds() === DEFAULT_MILLISECONDS;
        }
        Object.defineProperty(DateTime, "defaultValue", {
            get: function () {
                return DateTime.defaultValueField;
            },
            enumerable: false,
            configurable: true
        });
        DateTime.prototype.nativeDefaultDate = function () {
            return new Date(DEFAULT_YEAR, DEFAULT_MONTH, DEFAULT_DAY, DEFAULT_HOURS, DEFAULT_MINUTES, DEFAULT_SECONDS, DEFAULT_MILLISECONDS);
        };
        Object.defineProperty(DateTime.prototype, "isDefault", {
            get: function () {
                return this.isDefaultDate;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTime.prototype, "year", {
            get: function () {
                return this.isDefault ? DEFAULT_YEAR : this.date.getFullYear();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTime.prototype, "month", {
            get: function () {
                return this.isDefault ? DEFAULT_MONTH + 1 : this.date.getMonth() + 1;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTime.prototype, "day", {
            get: function () {
                return this.isDefault ? DEFAULT_DAY : this.date.getDate();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTime.prototype, "hours", {
            get: function () {
                return this.isDefault ? DEFAULT_HOURS : this.date.getHours();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTime.prototype, "minutes", {
            get: function () {
                return this.isDefault ? DEFAULT_MINUTES : this.date.getMinutes();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTime.prototype, "seconds", {
            get: function () {
                return this.isDefault ? DEFAULT_SECONDS : this.date.getSeconds();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTime.prototype, "milliseconds", {
            get: function () {
                return this.isDefault ? DEFAULT_MILLISECONDS : this.date.getMilliseconds();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(DateTime.prototype, "weekDay", {
            get: function () {
                return this.isDefault ? DEFAULT_WEEKDAY : this.date.getDay();
            },
            enumerable: false,
            configurable: true
        });
        DateTime.prototype.addYears = function (years) {
            var dt = new DateTime(this.year + years, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
            if (this.month === 2 && this.day === 29 && dt.month === 3) {
                return new DateTime(dt.year, 2, 28, dt.hours, dt.minutes, dt.seconds, dt.milliseconds);
            }
            return dt;
        };
        DateTime.prototype.daysInMonth = function (month, year) {
            return new Date(year, month, 0).getDate();
        };
        DateTime.prototype.addMonths = function (months) {
            var dt = new DateTime(this.year, this.month + months, this.day, this.hours, this.minutes, this.seconds, this.milliseconds);
            if (dt.day === this.day) {
                return dt;
            }
            return new DateTime(dt.year, dt.month - 1, this.daysInMonth(dt.month - 1, dt.year), dt.hours, dt.minutes, dt.seconds, dt.milliseconds);
        };
        DateTime.prototype.addDays = function (days) {
            return new DateTime(this.year, this.month, this.day + days, this.hours, this.minutes, this.seconds, this.milliseconds);
        };
        DateTime.prototype.addHours = function (hours) {
            return new DateTime(this.year, this.month, this.day, this.hours + hours, this.minutes, this.seconds, this.milliseconds);
        };
        DateTime.prototype.addMinutes = function (minutes) {
            return new DateTime(this.year, this.month, this.day, this.hours, this.minutes + minutes, this.seconds, this.milliseconds);
        };
        DateTime.prototype.addSeconds = function (seconds) {
            return new DateTime(this.year, this.month, this.day, this.hours, this.minutes, this.seconds + seconds, this.milliseconds);
        };
        DateTime.prototype.addMilliseconds = function (milliseconds) {
            return new DateTime(this.year, this.month, this.day, this.hours, this.minutes, this.seconds, this.milliseconds + milliseconds);
        };
        DateTime.prototype.equals = function (other) {
            return !!other && this.getTime() === other.getTime();
        };
        DateTime.prototype.eq = function (other) {
            return this.equals(other);
        };
        DateTime.prototype.greaterThan = function (other) {
            return this.date > other.date;
        };
        DateTime.prototype.gt = function (other) {
            return this.greaterThan(other);
        };
        DateTime.prototype.greaterThanOrEqualTo = function (other) {
            return this.date >= other.date;
        };
        DateTime.prototype.gte = function (other) {
            return this.greaterThanOrEqualTo(other);
        };
        DateTime.prototype.lessThan = function (other) {
            return this.date < other.date;
        };
        DateTime.prototype.lt = function (other) {
            return this.lessThan(other);
        };
        DateTime.prototype.lessThanOrEqualTo = function (other) {
            return this.date <= other.date;
        };
        DateTime.prototype.lte = function (other) {
            return this.lessThanOrEqualTo(other);
        };
        DateTime.prototype.toNative = function () {
            return this.isDefault ? this.nativeDefaultDate() : new Date(this.date.getTime());
        };
        DateTime.prototype.getTime = function () {
            return this.isDefault ? this.nativeDefaultDate().getTime() : this.date.getTime();
        };
        DateTime.prototype.valueOf = function () {
            return this.isDefault ? this.nativeDefaultDate().valueOf() : this.date.valueOf();
        };
        DateTime.fromISODate = function (value) {
            var valid = Constants.RFC3339_DATEPART.test(value);
            if (valid) {
                return DateTime.internalFromUTCWithoutConversion(value + "T00:00:00Z");
            }
            return DateTime.defaultValue;
        };
        DateTime.prototype.toISODate = function () {
            return this.toString(Constants.RFC3339_DATEPART_FORMAT);
        };
        DateTime.fromISOTime = function (value) {
            var valid = Constants.RFC3339_TIMEPART.test(value);
            if (valid) {
                return DateTime.internalFromUTCWithoutConversion("1900-01-01T" + value + "Z");
            }
            return DateTime.defaultValue;
        };
        DateTime.prototype.toISOTime = function () {
            return this.toString(Constants.RFC3339_TIMEPART_FORMAT);
        };
        DateTime.fromISODateTime = function (value) {
            value = value || "";
            if (value === "" || (value.indexOf("1900-01-01") >= 0 && value.indexOf("00:00:00") >= 0)) {
                return DateTime.defaultValue;
            }
            var rxTimezone = /([+\-]\d{2}((:\d{2})|(\d{2})?)|Z)$/;
            if (value.indexOf("T") > 0 && !rxTimezone.test(value)) {
                return DateTime.internalFromUTCWithoutConversion(value.trim() + "Z");
            }
            value = value.replace(/([+-]\d{2})$/, function fun(x) {
                return x + "00";
            });
            var parsedDate = Date.parse(value);
            if (!isNaN(parsedDate)) {
                return new DateTime(parsedDate);
            }
            return DateTime.defaultValue;
        };
        DateTime.internalFromUTCWithoutConversion = function (value) {
            var parsedDate = Date.parse(value);
            if (!isNaN(parsedDate)) {
                var dateInUTC = new Date(parsedDate);
                return new DateTime(dateInUTC.getUTCFullYear(), dateInUTC.getUTCMonth() + 1, dateInUTC.getUTCDate(), dateInUTC.getUTCHours(), dateInUTC.getUTCMinutes(), dateInUTC.getUTCSeconds(), dateInUTC.getUTCMilliseconds());
            }
            return DateTime.defaultValue;
        };
        DateTime.prototype.getMillisecondsString = function () {
            return (this.milliseconds / 1000).toFixed(3).substring(2, 5);
        };
        DateTime.prototype.toString = function (format) {
            var _this = this;
            if (arguments.length === 0) {
                if (this.equals(DateTime.defaultValue)) {
                    return "1900-01-01T00:00:00";
                }
                else {
                    return this.date.toISOString();
                }
            }
            return format.replace(/(\\.)|dd?d?d?|MM?M?M?|yy?y?y?|hh?|HH?|mm?|ss?|ff?f?|FF?F?|\.FF?F?|tt?|zz?z?/g, function (f) {
                if (f.indexOf("\\") === 0) {
                    return f.substring(1);
                }
                switch (f) {
                    case "hh":
                    case "h":
                        var normalizedHours = _this.hours < 13 ? _this.hours : _this.hours - 12;
                        return Format_1.DateTimeFormatInfo.padLeadingZeros((_this.hours === 0 ? 12 : normalizedHours).toString(), f.length);
                    case "HH":
                    case "H":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.hours.toString(), f.length);
                    case "mm":
                    case "m":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.minutes.toString(), f.length);
                    case "ss":
                    case "s":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.seconds.toString(), f.length);
                    case "fff":
                        return _this.getMillisecondsString();
                    case "ff":
                        return _this.getMillisecondsString().substring(0, 2);
                    case "f":
                        return _this.getMillisecondsString().substring(0, 1);
                    case ".FFF":
                    case ".FF":
                    case ".F":
                        return _this.milliseconds === 0
                            ? ""
                            : "." + Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString());
                    case "FFF":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString());
                    case "FF":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString()).substring(0, 2);
                    case "F":
                        return Format_1.DateTimeFormatInfo.removeTrailingZeros(_this.getMillisecondsString()).substring(0, 1);
                    case "yyyy":
                    case "yyy":
                        var year = _this.year.toString();
                        if (year.charAt(0) === "0") {
                            return _this.year.toString().substring(1);
                        }
                        return year;
                    case "yy":
                        return _this.year.toString().substring(2, 4);
                    case "y":
                        return Number(_this.year.toString().substring(2, 4)).toString();
                    case "dddd":
                        return Format_1.DateTimeFormatInfo.getDayName(_this.weekDay);
                    case "ddd":
                        return Format_1.DateTimeFormatInfo.getShortDayName(_this.weekDay);
                    case "dd":
                    case "d":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.day.toString(), f.length);
                    case "MMMM":
                        return Format_1.DateTimeFormatInfo.getMonthName(_this.month);
                    case "MMM":
                        return Format_1.DateTimeFormatInfo.getShortMonthName(_this.month);
                    case "MM":
                    case "M":
                        return Format_1.DateTimeFormatInfo.padLeadingZeros(_this.month.toString(), f.length);
                    case "t":
                        return Format_1.DateTimeFormatInfo.get12HourNotation(_this.hours).substring(0, 1);
                    case "tt":
                        return Format_1.DateTimeFormatInfo.get12HourNotation(_this.hours);
                    case "zzz":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationFull(_this.date.getTimezoneOffset());
                    case "zz":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationHoursFull(_this.date.getTimezoneOffset());
                    case "z":
                        return Format_1.DateTimeFormatInfo.getTimezoneInformationHoursShort(_this.date.getTimezoneOffset());
                    default:
                        return f;
                }
            });
        };
        DateTime.defaultValueField = new DateTime();
        return DateTime;
    }());
    exports.DateTime = DateTime;
    var Constants;
    (function (Constants) {
        Constants.RFC3339_TIMEPART = /^([01][0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9](\.\d+)?)?$/;
        Constants.RFC3339_DATEPART = /^\d{4,}-(0\d|1[012])-([0-2]\d|3[01])$/;
        Constants.RFC3339_TIMEPART_FORMAT = "HH:mm:ss";
        Constants.RFC3339_DATEPART_FORMAT = "yyyy-MM-dd";
        Constants.MIN_INTEGER_VALUE = -2147483648;
        Constants.MAX_INTEGER_VALUE = 2147483647;
        Constants.MIN_LONGINTEGER_VALUE = LongInteger_1.default.MIN_VALUE;
        Constants.MAX_LONGINTEGER_VALUE = LongInteger_1.default.MAX_VALUE;
        Constants.MIN_DECIMAL_VALUE = new Decimal_1.default("2").pow(96).neg();
        Constants.MAX_DECIMAL_VALUE = new Decimal_1.default("2").pow(96).minus(1);
        Constants.MIN_DATE_VALUE = new DateTime(1753, 1, 1);
        Constants.MAX_DATE_VALUE = new DateTime(9999, 12, 31);
        Constants.MIN_TIME_VALUE = DateTime.defaultValue;
        Constants.MAX_TIME_VALUE = DateTime.defaultValue.addHours(23).addMinutes(59).addSeconds(59);
        Constants.MIN_DATETIME_VALUE = new DateTime(1753, 1, 1, 0, 0, 0);
        Constants.MAX_DATETIME_VALUE = new DateTime(9999, 12, 31, 23, 59, 59);
        Constants.DEFAULT_INTEGER = 0;
        Constants.DEFAULT_LONGINTEGER = LongInteger_1.default.defaultValue;
        Constants.DEFAULT_DECIMAL = Decimal_1.default.defaultValue;
        Constants.DEFAULT_CURRENCY = Decimal_1.default.defaultValue;
        Constants.DEFAULT_TEXT = "";
        Constants.DEFAULT_PHONENUMBER = "";
        Constants.DEFAULT_EMAIL = "";
        Constants.DEFAULT_BOOLEAN = false;
        Constants.DEFAULT_DATE = DateTime.defaultValue;
        Constants.DEFAULT_DATETIME = DateTime.defaultValue;
        Constants.DEFAULT_TIME = DateTime.defaultValue;
        Constants.DEFAULT_BINARYDATA = BinaryData.defaultValue;
        Constants.DEFAULT_OBJECT = null;
        Constants.FORMAT = new Format_1.ApplicationFormatInfo(new Format_1.DateTimeFormatInfo("yyyy-MM-dd", "HH:mm:ss"), new Format_1.NumberFormatInfo(".", ""));
        Constants.ISO_DATE_FORMAT_REGEXP = /^\d{4,}-(0\d|1[012])-([0-2]\d|3[01])([T ]\d{2}:\d{2}(:\d{2}(\.\d+)?(([+\-]\d{2}((:\d{2})|(\d{2})?))|Z)?)?)?$/i;
    })(Constants || (exports.Constants = Constants = {}));
    var Cache = (function () {
        function Cache() {
            this.map = {};
        }
        Cache.prototype.getItem = function (key) {
            return this.map[key];
        };
        Cache.prototype.setItem = function (key, item) {
            this.map[key] = item;
        };
        Cache.prototype.invalidate = function (key) {
            if (key === undefined) {
                this.map = {};
            }
            else {
                this.setItem(key, undefined);
            }
        };
        Cache.prototype.clone = function () {
            var other = new Cache();
            for (var key in this.map) {
                other.setItem(key, this.map[key]);
            }
            return other;
        };
        return Cache;
    }());
    exports.Cache = Cache;
    var ListCache = (function () {
        function ListCache() {
            this.list = [];
        }
        ListCache.prototype.getItem = function (index) {
            if (index >= this.length) {
                return undefined;
            }
            return this.list[index];
        };
        ListCache.prototype.append = function (item) {
            this.list.push(item);
        };
        ListCache.prototype.appendMultiple = function (numberOfItems) {
            this.list = this.list.concat(new Array(numberOfItems));
        };
        ListCache.prototype.setItem = function (index, item) {
            this.list[index] = item;
        };
        ListCache.prototype.insert = function (index, item) {
            this.list.splice(index, 0, item);
        };
        ListCache.prototype.invalidate = function (index) {
            if (index === undefined) {
                this.list = [];
            }
            else {
                this.list.splice(index, 1);
            }
        };
        Object.defineProperty(ListCache.prototype, "length", {
            get: function () {
                return this.list.length;
            },
            enumerable: false,
            configurable: true
        });
        return ListCache;
    }());
    exports.ListCache = ListCache;
    function compare(v1, v2) {
        if (typeof v1 === "string") {
            var v1s = v1;
            var v2s = v2;
            return v1s.localeCompare(v2s);
        }
        if (typeof v1 === "number") {
            return v1 - v2;
        }
        if (typeof v1 === "boolean") {
            if (!v1 && v2) {
                return -1;
            }
            else if (v1 && !v2) {
                return 1;
            }
            else {
                return 0;
            }
        }
        if (v1.lessThan(v2)) {
            return -1;
        }
        else if (v1.greaterThan(v2)) {
            return 1;
        }
        else {
            return 0;
        }
    }
    exports.compare = compare;
    function equals(objA, objB) {
        if (!objA || !objB || !(objB.equals instanceof Function)) {
            return objB === objA;
        }
        return objB.equals(objA);
    }
    exports.equals = equals;
    function areBinaryNulls(left, right) {
        return !left.hasContent() && !right.hasContent();
    }
    exports.areBinaryNulls = areBinaryNulls;
    function defaultForType(t) {
        switch (t) {
            case DataTypes.Integer:
                return Constants.DEFAULT_INTEGER;
            case DataTypes.LongInteger:
                return Constants.DEFAULT_LONGINTEGER;
            case DataTypes.Decimal:
                return Constants.DEFAULT_DECIMAL;
            case DataTypes.Currency:
                return Constants.DEFAULT_CURRENCY;
            case DataTypes.Text:
                return Constants.DEFAULT_TEXT;
            case DataTypes.PhoneNumber:
                return Constants.DEFAULT_PHONENUMBER;
            case DataTypes.Email:
                return Constants.DEFAULT_EMAIL;
            case DataTypes.Date:
                return Constants.DEFAULT_DATE;
            case DataTypes.DateTime:
                return Constants.DEFAULT_DATETIME;
            case DataTypes.Time:
                return Constants.DEFAULT_TIME;
            case DataTypes.Boolean:
                return Constants.DEFAULT_BOOLEAN;
            case DataTypes.BinaryData:
                return Constants.DEFAULT_BINARYDATA;
            case DataTypes.Object:
                return Constants.DEFAULT_OBJECT;
            default:
                throw new TypeError("Records and Record lists are not basic types");
        }
    }
    exports.defaultForType = defaultForType;
    var ImmutableListWithTracking = (function () {
        function ImmutableListWithTracking(emptyListItem, data, itemIds, itemIdSeed, modelId) {
            this.emptyListItem = emptyListItem;
            this.data = data || new LightImmutable_1.ImmutableList();
            this.itemIds = itemIds || new LightImmutable_1.ImmutableList();
            this._itemIdSeed = itemIdSeed || 0;
            this._modelId = modelId || ImmutableListWithTracking.nextModelId++;
            if (data && !itemIds) {
                for (var i = 0, len = this.data.count(); i < len; i++) {
                    this.itemIds = this.itemIds.push(this._itemIdSeed);
                    this._itemIdSeed = (this._itemIdSeed + 1) | 0;
                }
            }
        }
        Object.defineProperty(ImmutableListWithTracking.prototype, "modelId", {
            get: function () {
                return this._modelId;
            },
            enumerable: false,
            configurable: true
        });
        ImmutableListWithTracking.prototype.push = function (value) {
            return new ImmutableListWithTracking(this.emptyListItem, this.data.push(value), this.itemIds.push(this._itemIdSeed), (this._itemIdSeed + 1) | 0, this._modelId);
        };
        ImmutableListWithTracking.prototype.addFromOther = function (values) {
            var _this = this;
            return new ImmutableListWithTracking(this.emptyListItem, this.data.addFromOther(values.data), this.itemIds.pushAll(values.data.map(function () { return _this._itemIdSeed++; })), this._itemIdSeed, this._modelId);
        };
        ImmutableListWithTracking.prototype.pushAll = function (values) {
            var _this = this;
            return new ImmutableListWithTracking(this.emptyListItem, this.data.pushAll(values), this.itemIds.pushAll(values.map(function () { return _this._itemIdSeed++; })), this._itemIdSeed, this._modelId);
        };
        ImmutableListWithTracking.prototype.remove = function (index) {
            return new ImmutableListWithTracking(this.emptyListItem, this.data.remove(index), this.itemIds.remove(index), this._itemIdSeed, this._modelId);
        };
        ImmutableListWithTracking.prototype.insert = function (index, value) {
            return new ImmutableListWithTracking(this.emptyListItem, this.data.insert(index, value), this.itemIds.insert(index, this._itemIdSeed), (this._itemIdSeed + 1) | 0, this._modelId);
        };
        ImmutableListWithTracking.prototype.sort = function (get, by, ascending) {
            var _this = this;
            var combinedList = this.data.map(function (item, index) {
                return {
                    item: get(index),
                    itemId: _this.itemIds.get(index),
                    by: by(get(index)),
                };
            });
            var factor = ascending ? 1 : -1;
            combinedList.sort(function (v1, v2) { return factor * compare(v1.by, v2.by); });
            var newData = LightImmutable_1.ImmutableList.fromJS(combinedList.map(function (v) { return v.item; }));
            var newIds = LightImmutable_1.ImmutableList.fromJS(combinedList.map(function (v) { return v.itemId; }));
            return new ImmutableListWithTracking(this.emptyListItem, newData, newIds, this._itemIdSeed, this._modelId);
        };
        ImmutableListWithTracking.prototype.getEmptyListItem = function () {
            return this.emptyListItem;
        };
        ImmutableListWithTracking.prototype.setEmptyListItem = function (value) {
            return new ImmutableListWithTracking(value, this.data, this.itemIds, this._itemIdSeed, this._modelId);
        };
        ImmutableListWithTracking.prototype.get = function (index) {
            return this.data.get(index);
        };
        ImmutableListWithTracking.prototype.getId = function (index) {
            return (0, Settings_1.getEnvParams)().ListItemIdWithoutModelId
                ? this.itemIds.get(index) + ""
                : "".concat(this.modelId, "_").concat(this.itemIds.get(index));
        };
        ImmutableListWithTracking.prototype.count = function () {
            return this.data.count();
        };
        ImmutableListWithTracking.prototype.isEmpty = function () {
            return this.data.isEmpty();
        };
        ImmutableListWithTracking.prototype.set = function (index, value) {
            return new ImmutableListWithTracking(this.emptyListItem, this.data.set(index, value), this.itemIds, this._itemIdSeed, this._modelId);
        };
        ImmutableListWithTracking.prototype.clear = function () {
            return new ImmutableListWithTracking(this.emptyListItem, this.data.clear(), this.itemIds.clear(), this._itemIdSeed, this._modelId);
        };
        ImmutableListWithTracking.prototype.forEach = function (cb) {
            return this.data.forEach(cb);
        };
        ImmutableListWithTracking.prototype.reduce = function (reducer, init) {
            return this.data.reduce(reducer, init);
        };
        ImmutableListWithTracking.fromJS = function (items, emptyListItem) {
            return new ImmutableListWithTracking(emptyListItem, LightImmutable_1.ImmutableList.fromJS(items));
        };
        ImmutableListWithTracking.fromJSON = function (items, emptyListItem) {
            return new ImmutableListWithTracking(emptyListItem, LightImmutable_1.ImmutableList.fromJS(items));
        };
        ImmutableListWithTracking.prototype.clone = function () {
            return new ImmutableListWithTracking(this.emptyListItem, this.data.clone(), this.itemIds.clone(), this._itemIdSeed);
        };
        ImmutableListWithTracking.nextModelId = 1;
        return ImmutableListWithTracking;
    }());
    exports.ImmutableListWithTracking = ImmutableListWithTracking;
    var ImmutableBase = (function () {
        function ImmutableBase() {
            this.writePropagateHandler = this.defaultWritePropagate;
            this.propagationParent = this;
        }
        ImmutableBase.getData = function (other) {
            if (other === undefined || other.constructor === ImmutableListWithTracking) {
                return undefined;
            }
            return other.data;
        };
        ImmutableBase.setPropagationHandler = function (other, parent, key, writePropagationHandler) {
            other.writePropagateHandler = writePropagationHandler;
            ImmutableBase.setPropagationParent(other, parent);
            ImmutableBase.setPropagationKey(other, key);
        };
        ImmutableBase.setPropagationParent = function (other, parent) {
            other.propagationParent = parent;
        };
        ImmutableBase.setPropagationKey = function (other, key) {
            other.propagationKey = key;
        };
        ImmutableBase.prototype.writePropagate = function (newValue, cache) {
            if (this.data.constructor !== newValue.constructor) {
                throw new Error("Unexpected new data type");
            }
            this.data = newValue;
            this.writePropagateHandler.apply(this.propagationParent, [this.propagationKey, newValue, cache]);
        };
        ImmutableBase.prototype.defaultWritePropagate = function (key, newValue, cache) {
            this.onDefaultWritePropagate(cache);
        };
        ImmutableBase.prototype.onDefaultWritePropagate = function (cache) { };
        return ImmutableBase;
    }());
    exports.ImmutableBase = ImmutableBase;
    var Record = (function (_super) {
        tslib_1.__extends(Record, _super);
        function Record(defaults, cache) {
            var _this = _super.call(this) || this;
            _this.cache = cache || new Cache();
            if (defaults) {
                _this.data = defaults;
            }
            else {
                _this.data = _this.constructor.createDefaultData();
            }
            return _this;
        }
        Record.createDefaultData = function () {
            var classDef = this;
            var recordClass = classDef.RecordClass;
            if (recordClass) {
                return new recordClass();
            }
            return undefined;
        };
        Record.prototype.getBasicProperty = function (propertyName) {
            return this.data.get(propertyName);
        };
        Record.prototype.setBasicProperty = function (propertyName, value, expectedType, valueType) {
            if (this.data.get(propertyName) !== value) {
                Record.checkType(expectedType, value, valueType);
                this.writePropagate(this.data.set(propertyName, value), this.cache);
                this.onPropertyValueChanged(propertyName);
            }
        };
        Record.prototype.onPropertyValueChanged = function (propertyName) {
        };
        Record.prototype.getComplexProperty = function (propertyName, ctor) {
            var result = this.cache.getItem(propertyName);
            if (result) {
                Record.setPropagationParent(result, this);
                return result;
            }
            var propertyData = this.data.get(propertyName);
            var propertyCache = this.cache.getItem(propertyName + CACHE_SUFFIX);
            result = new ctor(propertyData, propertyCache ? propertyCache : null);
            this.cache.setItem(propertyName, result);
            if (propertyCache) {
                this.cache.invalidate(propertyName + CACHE_SUFFIX);
            }
            Record.setPropagationHandler(result, this, propertyName, this.internalSetComplexProperty);
            return result;
        };
        Record.prototype.setComplexProperty = function (propertyName, value, expectedType, valueType) {
            this.setProperties([
                { name: propertyName, value: value, expectedType: expectedType, valueType: valueType, isBasicType: false },
            ]);
        };
        Record.prototype.internalSetComplexProperty = function (propertyName, value, cache) {
            this.internalSetProperties([{ name: propertyName, value: value, isBasicType: false }], cache);
        };
        Record.prototype.setProperties = function (properties) {
            var changedProperties = [];
            for (var _i = 0, properties_1 = properties; _i < properties_1.length; _i++) {
                var property = properties_1[_i];
                var objData = Record.getData(property.value) || property.value;
                if (this.data.get(property.name) !== objData) {
                    if (property.expectedType !== undefined) {
                        Record.checkType(property.expectedType, property.value, property.valueType);
                    }
                    changedProperties.push({ name: property.name, value: objData, isBasicType: property.isBasicType });
                }
            }
            if (changedProperties.length > 0) {
                this.internalSetProperties(changedProperties);
            }
        };
        Record.prototype.internalSetProperties = function (properties, cache) {
            var newData = this.data;
            var clonedCache = this.cloneCache();
            for (var _i = 0, properties_2 = properties; _i < properties_2.length; _i++) {
                var property = properties_2[_i];
                newData = newData.set(property.name, property.value);
                if (!property.isBasicType) {
                    clonedCache.invalidate(property.name);
                    clonedCache.invalidate(property.name + CACHE_SUFFIX);
                    if (cache) {
                        clonedCache.setItem(property.name + CACHE_SUFFIX, cache);
                    }
                }
            }
            this.writePropagate(newData, clonedCache);
            for (var _a = 0, properties_3 = properties; _a < properties_3.length; _a++) {
                var property = properties_3[_a];
                this.onPropertyValueChanged(property.name);
            }
        };
        Record.prototype.cloneCache = function () {
            return this.cache.clone();
        };
        Record.prototype.onDefaultWritePropagate = function (cache) {
            this.cache = cache;
        };
        Record.checkType = function (expectedType, value, valueType) {
            switch (expectedType) {
                case DataTypes.Integer:
                    Record.ensureValidInteger(value);
                    break;
                case DataTypes.LongInteger:
                    Record.ensureValidLongInteger(value);
                    break;
                case DataTypes.Decimal:
                case DataTypes.Currency:
                    Record.ensureValidDecimal(value);
                    break;
                case DataTypes.Text:
                case DataTypes.PhoneNumber:
                    Record.ensureValidText(value);
                    break;
                case DataTypes.Email:
                    Record.ensureValidEmail(value);
                    break;
                case DataTypes.Boolean:
                    Record.ensureValidBoolean(value);
                    break;
                case DataTypes.Date:
                    Record.ensureValidDate(value);
                    break;
                case DataTypes.Time:
                    Record.ensureValidTime(value);
                    break;
                case DataTypes.DateTime:
                    Record.ensureValidDateTime(value);
                    break;
                case DataTypes.Record:
                case DataTypes.RecordList:
                    Record.ensureValidComplexType(value, valueType);
                    break;
                case DataTypes.BinaryData:
                    Record.ensureValidBinaryData(value);
                    break;
                case DataTypes.Object:
                    break;
                default:
                    throw new TypeError("Unexpected data type: " + expectedType);
            }
        };
        Record.ensureValidBinaryData = function (value) {
            if (typeof value === "string" || value instanceof BinaryData) {
                return;
            }
            throw new TypeError("Expecting a Binary Data, found: " + value);
        };
        Record.ensureValidInteger = function (value) {
            if (typeof value === "number" && !isNaN(value) && value % 1 === 0) {
                if (value < Constants.MIN_INTEGER_VALUE) {
                    throw new TypeError("Integers must be greater than " + Constants.MIN_INTEGER_VALUE + ", found: " + value);
                }
                else if (value > Constants.MAX_INTEGER_VALUE) {
                    throw new TypeError("Integers must be lower than " + Constants.MAX_INTEGER_VALUE + ", found: " + value);
                }
            }
            else {
                throw new TypeError("Expecting an Integer, found: " + value);
            }
        };
        Record.ensureValidLongInteger = function (value) {
            if (value && value.constructor === LongInteger_1.default) {
                if (value.lessThan(Constants.MIN_LONGINTEGER_VALUE)) {
                    throw new TypeError("Long Integers must be greater than " +
                        Constants.MIN_LONGINTEGER_VALUE.toString() +
                        ", found: " +
                        value.toString());
                }
                else if (value.greaterThan(Constants.MAX_LONGINTEGER_VALUE)) {
                    throw new TypeError("Long Integers must be lower than " +
                        Constants.MAX_LONGINTEGER_VALUE.toString() +
                        ", found: " +
                        value.toString());
                }
            }
            else {
                throw new TypeError("Expecting a LongInteger, found: " + value);
            }
        };
        Record.ensureValidDecimal = function (value) {
            if (value && value.constructor === Decimal_1.default) {
                if (value.lessThan(Constants.MIN_DECIMAL_VALUE)) {
                    throw new TypeError("Decimals must be greater than " +
                        Constants.MIN_DECIMAL_VALUE.toString() +
                        ", found: " +
                        value.toString());
                }
                else if (value.greaterThan(Constants.MAX_DECIMAL_VALUE)) {
                    throw new TypeError("Decimals must be lower than " +
                        Constants.MAX_DECIMAL_VALUE.toString() +
                        ", found: " +
                        value.toString());
                }
            }
            else {
                throw new TypeError("Expecting a Decimal, found: ".concat(value));
            }
        };
        Record.ensureValidText = function (value) {
            if (typeof value === "string") {
                return;
            }
            throw new TypeError("Expecting a Text, found: ".concat(value));
        };
        Record.ensureValidEmail = function (value) {
            if (typeof value === "string") {
                return;
            }
            throw new TypeError("Expecting an Email, found: ".concat(value));
        };
        Record.ensureValidBoolean = function (value) {
            if (typeof value === "boolean") {
                return;
            }
            throw new TypeError("Expecting a Boolean, found: ".concat(value));
        };
        Record.ensureValidDate = function (value) {
            if (!!value && value.constructor === DateTime) {
                return;
            }
            throw new TypeError("Expecting a Date, found: ".concat(value));
        };
        Record.ensureValidTime = function (value) {
            if (!!value && value.constructor === DateTime) {
                return;
            }
            throw new TypeError("Expecting a Time, found: ".concat(value));
        };
        Record.ensureValidDateTime = function (value) {
            if (!!value && value.constructor === DateTime) {
                return;
            }
            throw new TypeError("Expecting a DateTime, found: ".concat(value));
        };
        Record.ensureValidComplexType = function (value, valueType) {
            if (!!value) {
                if (value.constructor === valueType) {
                    return;
                }
                if (value.isCompatibleWith !== undefined) {
                    if (value.isCompatibleWith(valueType)) {
                        return;
                    }
                    throw new TypeError("Expecting a ".concat(valueType.name, " type, found:  ").concat(value.constructor.name));
                }
            }
            throw new TypeError("Expecting a Record or RecordList, found: ".concat(value));
        };
        Record.prototype.replaceWith = function (other) {
            var data = Record.getData(other);
            this.writePropagate(data, new Cache());
        };
        Record.prototype.fastEquals = function (other) {
            return this === other;
        };
        Record.prototype.equals = function (other) {
            if (!other || this.constructor !== other.constructor) {
                return false;
            }
            return true;
        };
        Record.defineRecordClass = function (defaultValues) {
            return (0, LightImmutable_1.defineRecordClass)(defaultValues);
        };
        Record.prototype.clone = function () {
            var ctor = this.constructor;
            return new ctor(this.data, this.cloneCache());
        };
        return Record;
    }(ImmutableBase));
    exports.Record = Record;
    var StaticAttrDefinition = (function () {
        function StaticAttrDefinition(name, attrName, nameForJson, mandatory, ignoreForServer, dataType, defaultValueGetter, optimizeList, complexType) {
            this.name = name;
            this.attrName = attrName;
            this.nameForJson = nameForJson;
            this.mandatory = mandatory;
            this.ignoreForServer = ignoreForServer;
            this.dataType = dataType;
            this.optimizeList = optimizeList;
            this.complexType = complexType;
            this.defaultValue = defaultValueGetter();
        }
        return StaticAttrDefinition;
    }());
    var DynamicAttrDefinition = (function () {
        function DynamicAttrDefinition(name, attrName, nameForJson, mandatory, ignoreForServer, dataType, defaultValueGetter, optimizeList, complexType) {
            this.name = name;
            this.attrName = attrName;
            this.nameForJson = nameForJson;
            this.mandatory = mandatory;
            this.ignoreForServer = ignoreForServer;
            this.dataType = dataType;
            this.defaultValueGetter = defaultValueGetter;
            this.optimizeList = optimizeList;
            this.complexType = complexType;
        }
        Object.defineProperty(DynamicAttrDefinition.prototype, "defaultValue", {
            get: function () {
                return this.defaultValueGetter();
            },
            enumerable: false,
            configurable: true
        });
        return DynamicAttrDefinition;
    }());
    function dataTypeImplementsEquals(dataType) {
        return (dataType === DataTypes.Record ||
            dataType === DataTypes.RecordList ||
            dataType === DataTypes.LongInteger ||
            dataType === DataTypes.Decimal ||
            dataType === DataTypes.Currency ||
            dataType === DataTypes.DateTime ||
            dataType === DataTypes.Time ||
            dataType === DataTypes.Date);
    }
    var GenericRecord = (function (_super) {
        tslib_1.__extends(GenericRecord, _super);
        function GenericRecord(defaults, cache) {
            return _super.call(this, defaults, cache) || this;
        }
        Object.defineProperty(GenericRecord, "isGenericRecordType", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        GenericRecord.prototype.getAttributes = function () {
            return this.constructor.Attributes || [];
        };
        GenericRecord.getAttributes = function () {
            return this.Attributes || [];
        };
        GenericRecord.isAnonymousRecord = function () {
            return this._isAnonymousRecord;
        };
        GenericRecord.attr = function (name, attrName, nameForJson, mandatory, ignoreForServer, dataType, defaultValue, optimizeListOrComplexType, complexType) {
            if (optimizeListOrComplexType === void 0) { optimizeListOrComplexType = true; }
            var optimizeList;
            if (typeof optimizeListOrComplexType !== "boolean") {
                complexType = optimizeListOrComplexType;
                optimizeList = true;
            }
            else {
                optimizeList = optimizeListOrComplexType;
            }
            if (dataType === DataTypes.DateTime || dataType === DataTypes.Date || dataType === DataTypes.Time) {
                return new DynamicAttrDefinition(name, attrName, nameForJson, mandatory, ignoreForServer, dataType, defaultValue, optimizeList, complexType);
            }
            else {
                return new StaticAttrDefinition(name, attrName, nameForJson, mandatory, ignoreForServer, dataType, defaultValue, optimizeList, complexType);
            }
        };
        GenericRecord.attributesToDeclare = function () {
            return [];
        };
        GenericRecord.init = function () {
            var classDef = this;
            var attributes = classDef.attributesToDeclare();
            classDef.Attributes = attributes;
            attributes.forEach(function (attr) {
                if (!(attr.attrName in classDef.prototype)) {
                    if (attr.dataType === DataTypes.Record || attr.dataType === DataTypes.RecordList) {
                        classDef.defineComplexProperty(attr.attrName, attr.dataType, attr.complexType);
                    }
                    else {
                        classDef.defineBasicProperty(attr.attrName, attr.dataType);
                    }
                }
            });
            classDef.RecordClass = Record.defineRecordClass(attributes.reduce(function (recordAttributes, attr) {
                recordAttributes[attr.attrName] = null;
                return recordAttributes;
            }, {}));
            classDef.prototype.equals = (0, Settings_1.getEnvParams)().EnforceUnsafeEval ? equalsWithEval() : equalsWithoutEval();
            function equalsWithEval() {
                var equalsCode = "return function equals(other) {\n";
                equalsCode += "    return _super.prototype.equals.call(this, other)";
                attributes.forEach(function (attr) {
                    if (dataTypeImplementsEquals(attr.dataType)) {
                        equalsCode += " &&\n        this.".concat(attr.attrName, ".equals(other.").concat(attr.attrName, ")");
                    }
                    else {
                        equalsCode += " &&\n        (this.".concat(attr.attrName, " === other.").concat(attr.attrName, ")");
                    }
                });
                equalsCode += ";\n";
                equalsCode += "};";
                return new Function("_super", equalsCode)(GenericRecord);
            }
            function equalsWithoutEval() {
                return function (other) {
                    var _this = this;
                    return (GenericRecord.prototype.equals.call(this, other) &&
                        attributes.every(function (attr) {
                            return dataTypeImplementsEquals(attr.dataType)
                                ? _this[attr.attrName].equals(other[attr.attrName])
                                : _this[attr.attrName] === other[attr.attrName];
                        }));
                };
            }
        };
        GenericRecord.createDefaultData = function () {
            var classDef = this;
            var recordClass = classDef.RecordClass;
            if (recordClass) {
                var defaultData = {};
                for (var _i = 0, _a = classDef.Attributes; _i < _a.length; _i++) {
                    var attr = _a[_i];
                    if (attr.dataType === DataTypes.Record || attr.dataType === DataTypes.RecordList) {
                        defaultData[attr.attrName] = Record.getData(attr.defaultValue);
                    }
                    else {
                        defaultData[attr.attrName] = attr.defaultValue;
                    }
                }
                return new recordClass(defaultData);
            }
            return undefined;
        };
        GenericRecord.defineBasicProperty = function (attrName, dataType) {
            Object.defineProperty(this.prototype, attrName, {
                enumerable: true,
                configurable: true,
                get: function () {
                    return this.getBasicProperty(attrName);
                },
                set: function (value) {
                    this.setBasicProperty(attrName, value, dataType);
                },
            });
        };
        GenericRecord.defineComplexProperty = function (attrName, dataType, runtimeType) {
            Object.defineProperty(this.prototype, attrName, {
                enumerable: true,
                configurable: true,
                get: function () {
                    return this.getComplexProperty(attrName, runtimeType);
                },
                set: function (value) {
                    this.setComplexProperty(attrName, value, dataType, runtimeType);
                },
            });
        };
        GenericRecord.isCompatibleWith = function (otherRecordType) {
            if (this === otherRecordType) {
                return true;
            }
            return (this.isAnonymousRecord() &&
                otherRecordType.isAnonymousRecord() &&
                this.UniqueId === otherRecordType.UniqueId);
        };
        GenericRecord.prototype.isCompatibleWith = function (otherType) {
            return (otherType.prototype instanceof GenericRecord &&
                this.constructor.isCompatibleWith(otherType));
        };
        GenericRecord.prototype.getNonSerializableAttributes = function () {
            return this.getAttributes()
                .filter(function (a) { return a.dataType === DataTypes.Object; })
                .map(function (a) { return a.attrName; });
        };
        GenericRecord.UniqueId = "";
        GenericRecord._isAnonymousRecord = false;
        return GenericRecord;
    }(Record));
    exports.GenericRecord = GenericRecord;
    var List = (function (_super) {
        tslib_1.__extends(List, _super);
        function List() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        List.getItemType = function () {
            return this.itemType;
        };
        List.prototype.getCache = function () {
            return null;
        };
        List.prototype.newItem = function (defaults) {
            throw new Error("@abstract");
        };
        List.prototype.resetEmptyListItem = function () {
            this.data = this.data.setEmptyListItem(this.newItem());
        };
        Object.defineProperty(List.prototype, "emptyListItem", {
            get: function () {
                return this.isEmpty ? this.data.getEmptyListItem() : this.data.get(0);
            },
            set: function (value) {
                if (this.isEmpty) {
                    if (this.data.getEmptyListItem() === value) {
                        return;
                    }
                    this.writePropagate(this.data.setEmptyListItem(value), this.getCache());
                }
                else {
                    if (this.data.get(0) === value) {
                        return;
                    }
                    this.writePropagate(this.data.set(0, value), this.getCache());
                }
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(List.prototype, "modelId", {
            get: function () {
                return this.data.modelId;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(List.prototype, "isEmpty", {
            get: function () {
                return this.data.isEmpty();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(List.prototype, "length", {
            get: function () {
                return this.data.count();
            },
            enumerable: false,
            configurable: true
        });
        List.prototype.isValidIndex = function (index, acceptNextIndex) {
            if (acceptNextIndex === void 0) { acceptNextIndex = false; }
            return index % 1 === 0 && index >= 0 && index < this.length + (acceptNextIndex ? 1 : 0);
        };
        List.prototype.checkIndex = function (index, acceptNextIndex) {
            if (acceptNextIndex === void 0) { acceptNextIndex = false; }
            if (!this.isValidIndex(index, acceptNextIndex)) {
                var msg = "Index out of bounds. Index " + index + " for ";
                if (this.isEmpty) {
                    msg += "empty list.";
                }
                else {
                    msg += "bounds [0, " + (this.length - 1) + "].";
                }
                throw new Error(msg);
            }
        };
        List.prototype.idOf = function (index) {
            this.checkIndex(index);
            return this.data.getId(index);
        };
        List.prototype.append = function (value) {
            this.writePropagate(this.data.push(value), this.getCache());
        };
        List.prototype.appendAll = function (listToAppend) {
            if (listToAppend.length > 0) {
                this.writePropagate(this.data.addFromOther(listToAppend.data), this.getCache());
            }
        };
        List.prototype.pushAll = function (listToAppend) {
            if (listToAppend.length > 0) {
                this.writePropagate(this.data.pushAll(listToAppend), this.getCache());
            }
        };
        List.prototype.insert = function (index, value) {
            this.checkIndex(index, true);
            this.writePropagate(this.data.insert(index, value), this.getCache());
        };
        List.prototype.remove = function (index) {
            this.checkIndex(index);
            if (this.length === 1) {
                this.resetEmptyListItem();
            }
            this.writePropagate(this.data.remove(index), this.getCache());
        };
        List.prototype.clear = function () {
            this.resetEmptyListItem();
            this.writePropagate(this.data.clear(), this.getCache());
        };
        List.prototype.indexOf = function (condition) {
            for (var i = 0; i < this.length; i++) {
                if (condition(this.getItem(i))) {
                    return i;
                }
            }
            return -1;
        };
        List.prototype.any = function (condition) {
            return this.indexOf(condition) !== -1;
        };
        List.prototype.all = function (condition) {
            return !this.any(function (elem) { return !condition(elem); });
        };
        List.prototype.filter = function (condition) {
            var result = new this.constructor();
            var elements = [];
            for (var i = 0; i < this.length; i++) {
                var item = this.getItem(i);
                if (condition(item)) {
                    elements.push(item);
                }
            }
            result.pushAll(elements);
            return result;
        };
        List.prototype.distinct = function () {
            var result = new this.constructor();
            var distinctItemIndexes = new Array();
            for (var i = 0; i < this.length; i++) {
                var current = this.getItem(i);
                var isToInsert = true;
                for (var j = 0; j < distinctItemIndexes.length; j++) {
                    if (equals(current, this.getItem(distinctItemIndexes[j]))) {
                        isToInsert = false;
                        break;
                    }
                }
                if (isToInsert) {
                    distinctItemIndexes.push(i);
                    result.append(current);
                }
            }
            return result;
        };
        List.prototype.sort = function (by, ascending) {
            var elements = [];
            for (var i = 0; i < this.length; i++) {
                elements[i] = this.getItem(i);
            }
            var factor = ascending ? 1 : -1;
            elements.sort(function (v1, v2) { return factor * compare(by(v1), by(v2)); });
            this.clear();
            this.pushAll(elements);
        };
        List.prototype.getCurrent = function (context) {
            if (this.isEmpty) {
                return this.emptyListItem;
            }
            else {
                var currentRowNumber = this.getCurrentRowNumber(context);
                return this.getItem(currentRowNumber);
            }
        };
        List.prototype.getCurrentRowNumber = function (context) {
            return context.getCurrentRowNumber(this);
        };
        List.prototype.getItem = function (index) {
            this.checkIndex(index);
            return this.data.get(index);
        };
        List.prototype.setCurrent = function (context, value) {
            if (this.isEmpty) {
                this.emptyListItem = value;
            }
            else {
                var currentRowNumber = this.getCurrentRowNumber(context);
                this.setItem(currentRowNumber, value);
            }
        };
        List.prototype.setItem = function (index, value) {
            this.checkIndex(index);
            if (this.data.get(index) !== value) {
                this.writePropagate(this.data.set(index, value), this.getCache());
            }
        };
        List.prototype.fastEquals = function (other) {
            return this === other;
        };
        List.prototype.equals = function (other) {
            if (!other || this.constructor !== other.constructor || this.length !== other.length) {
                return false;
            }
            if (this.isEmpty) {
                var thisEmptyListItem = this.emptyListItem;
                var otherEmptyListItem = other.emptyListItem;
                return equals(thisEmptyListItem, otherEmptyListItem);
            }
            else {
                for (var i = 0; i < this.length; i++) {
                    var thisItem = this.getItem(i);
                    var otherItem = other.getItem(i);
                    var result = equals(thisItem, otherItem);
                    if (!result) {
                        return false;
                    }
                }
            }
            return true;
        };
        return List;
    }(ImmutableBase));
    exports.List = List;
    var BasicTypeList = (function (_super) {
        tslib_1.__extends(BasicTypeList, _super);
        function BasicTypeList(defaults) {
            var _this = _super.call(this) || this;
            _this.data = defaults || new ImmutableListWithTracking(_this.newItem());
            return _this;
        }
        Object.defineProperty(BasicTypeList, "isBasicTypeListType", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        BasicTypeList.getTypeDefaultValue = function () {
            throw new Error("Not implemented: getTypeDefaultValue");
        };
        BasicTypeList.prototype.newItem = function () {
            var ctor = this.constructor;
            return ctor.getTypeDefaultValue();
        };
        BasicTypeList.prototype.clone = function () {
            var basicListType = this.constructor;
            var data = this.data.clone();
            return new basicListType(data);
        };
        return BasicTypeList;
    }(List));
    exports.BasicTypeList = BasicTypeList;
    var GenericRecordList = (function (_super) {
        tslib_1.__extends(GenericRecordList, _super);
        function GenericRecordList(defaults, cache) {
            var _this = _super.call(this) || this;
            _this._recordType = _this.constructor.getItemType();
            if (!_this._recordType) {
                throw new TypeError("GenericRecordLists must define a RecordType");
            }
            if (defaults) {
                _this.data = defaults;
            }
            else {
                _this.data = new ImmutableListWithTracking(GenericRecord.getData(_this.newItem()));
            }
            _this.cache = cache || new ListCache();
            return _this;
        }
        Object.defineProperty(GenericRecordList, "isGenericRecordListType", {
            get: function () {
                return true;
            },
            enumerable: false,
            configurable: true
        });
        GenericRecordList.prototype.getCache = function () {
            return this.cache;
        };
        GenericRecordList.prototype.newItem = function (defaults) {
            return new (this.getRecordType())(defaults);
        };
        GenericRecordList.prototype.resetEmptyListItem = function () {
            this.data = this.data.setEmptyListItem(GenericRecord.getData(this.newItem()));
        };
        GenericRecordList.prototype.getRecordType = function () {
            return this._recordType;
        };
        Object.defineProperty(GenericRecordList.prototype, "emptyListItem", {
            get: function () {
                return this.internalGetItem(0, this.isEmpty);
            },
            set: function (value) {
                if (this.isEmpty) {
                    this.internalSetEmptyListItem(0, value);
                }
                else {
                    this.internalSetItem(0, value);
                }
            },
            enumerable: false,
            configurable: true
        });
        GenericRecordList.prototype.append = function (value) {
            if (this.isEmpty) {
                this.cache.invalidate(0);
            }
            _super.prototype.append.call(this, GenericRecord.getData(value));
            this.cache.append(undefined);
        };
        GenericRecordList.prototype.appendAll = function (listToAppend) {
            if (this.isEmpty) {
                this.cache.invalidate(0);
            }
            _super.prototype.appendAll.call(this, listToAppend);
            this.cache.appendMultiple(listToAppend.length);
        };
        GenericRecordList.prototype.pushAll = function (listToAppend) {
            if (this.isEmpty) {
                this.cache.invalidate(0);
            }
            _super.prototype.pushAll.call(this, listToAppend.map(function (item) { return Record.getData(item); }));
            this.cache.appendMultiple(listToAppend.length);
        };
        GenericRecordList.prototype.insert = function (index, value) {
            this.checkIndex(index, true);
            if (this.isEmpty) {
                this.cache.invalidate(0);
            }
            _super.prototype.insert.call(this, index, GenericRecord.getData(value));
            this.cache.insert(index, undefined);
        };
        GenericRecordList.prototype.getItem = function (index) {
            return this.internalGetItem(index, false);
        };
        GenericRecordList.prototype.internalGetItem = function (index, returnEmptyListItem) {
            if (!returnEmptyListItem) {
                this.checkIndex(index);
            }
            var result = this.cache.getItem(index);
            if (result) {
                GenericRecordList.setPropagationParent(result, this);
                GenericRecordList.setPropagationKey(result, index);
                return result;
            }
            if (returnEmptyListItem) {
                result = this.newItem(this.data.getEmptyListItem());
                GenericRecordList.setPropagationHandler(result, this, index, this.internalSetEmptyListItem);
            }
            else {
                result = this.newItem(this.data.get(index));
                GenericRecordList.setPropagationHandler(result, this, index, this.internalSetItem);
            }
            this.cache.setItem(index, result);
            return result;
        };
        GenericRecordList.prototype.setItem = function (index, value) {
            this.internalSetItem(index, value);
        };
        GenericRecordList.prototype.internalSetItem = function (index, value, cache) {
            var newData = GenericRecord.getData(value) || value;
            this.checkIndex(index);
            if (this.data.get(index) !== newData) {
                this.writePropagate(this.data.set(index, newData), this.cache);
                this.cache.setItem(index, undefined);
            }
        };
        GenericRecordList.prototype.internalSetEmptyListItem = function (index, value, cache) {
            var newData = GenericRecord.getData(value) || value;
            if (this.data.getEmptyListItem() !== newData) {
                this.writePropagate(this.data.setEmptyListItem(newData), this.cache);
                this.cache.setItem(index, undefined);
            }
        };
        GenericRecordList.prototype.remove = function (index) {
            _super.prototype.remove.call(this, index);
            this.cache.invalidate(index);
        };
        GenericRecordList.prototype.clear = function () {
            _super.prototype.clear.call(this);
            this.cache.invalidate();
        };
        GenericRecordList.prototype.readAll = function (readDb, dbRecords) {
            var records = [];
            for (var i = 0; i < dbRecords.length; i++) {
                var record = this.newItem();
                readDb(record, dbRecords.item(i));
                records.push(record);
            }
            this.pushAll(records);
        };
        GenericRecordList.prototype.clone = function () {
            var ctor = this.constructor;
            var data = this.data.clone();
            return new ctor(data);
        };
        GenericRecordList.isCompatibleWith = function (otherRecordListType) {
            if (this === otherRecordListType) {
                return true;
            }
            return this.getItemType().isCompatibleWith(otherRecordListType.getItemType());
        };
        GenericRecordList.prototype.isCompatibleWith = function (otherType) {
            return (otherType.prototype instanceof GenericRecordList &&
                this.constructor.isCompatibleWith(otherType));
        };
        return GenericRecordList;
    }(List));
    exports.GenericRecordList = GenericRecordList;
    var IntegerList = (function (_super) {
        tslib_1.__extends(IntegerList, _super);
        function IntegerList(defaults) {
            return _super.call(this, defaults) || this;
        }
        IntegerList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_INTEGER;
        };
        IntegerList.itemType = DataTypes.Integer;
        return IntegerList;
    }(BasicTypeList));
    exports.IntegerList = IntegerList;
    var LongIntegerList = (function (_super) {
        tslib_1.__extends(LongIntegerList, _super);
        function LongIntegerList(defaults) {
            return _super.call(this, defaults) || this;
        }
        LongIntegerList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_LONGINTEGER;
        };
        LongIntegerList.itemType = DataTypes.LongInteger;
        return LongIntegerList;
    }(BasicTypeList));
    exports.LongIntegerList = LongIntegerList;
    var DateList = (function (_super) {
        tslib_1.__extends(DateList, _super);
        function DateList(defaults) {
            return _super.call(this, defaults) || this;
        }
        DateList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_DATE;
        };
        DateList.itemType = DataTypes.Date;
        return DateList;
    }(BasicTypeList));
    exports.DateList = DateList;
    var DateTimeList = (function (_super) {
        tslib_1.__extends(DateTimeList, _super);
        function DateTimeList(defaults) {
            return _super.call(this, defaults) || this;
        }
        DateTimeList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_DATETIME;
        };
        DateTimeList.itemType = DataTypes.DateTime;
        return DateTimeList;
    }(BasicTypeList));
    exports.DateTimeList = DateTimeList;
    var TimeList = (function (_super) {
        tslib_1.__extends(TimeList, _super);
        function TimeList(defaults) {
            return _super.call(this, defaults) || this;
        }
        TimeList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_TIME;
        };
        TimeList.itemType = DataTypes.Time;
        return TimeList;
    }(BasicTypeList));
    exports.TimeList = TimeList;
    var DecimalList = (function (_super) {
        tslib_1.__extends(DecimalList, _super);
        function DecimalList(defaults) {
            return _super.call(this, defaults) || this;
        }
        DecimalList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_DECIMAL;
        };
        DecimalList.itemType = DataTypes.Decimal;
        return DecimalList;
    }(BasicTypeList));
    exports.DecimalList = DecimalList;
    var CurrencyList = (function (_super) {
        tslib_1.__extends(CurrencyList, _super);
        function CurrencyList(defaults) {
            return _super.call(this, defaults) || this;
        }
        CurrencyList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_CURRENCY;
        };
        CurrencyList.itemType = DataTypes.Currency;
        return CurrencyList;
    }(BasicTypeList));
    exports.CurrencyList = CurrencyList;
    var EmailList = (function (_super) {
        tslib_1.__extends(EmailList, _super);
        function EmailList(defaults) {
            return _super.call(this, defaults) || this;
        }
        EmailList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_EMAIL;
        };
        EmailList.itemType = DataTypes.Email;
        return EmailList;
    }(BasicTypeList));
    exports.EmailList = EmailList;
    var PhoneNumberList = (function (_super) {
        tslib_1.__extends(PhoneNumberList, _super);
        function PhoneNumberList(defaults) {
            return _super.call(this, defaults) || this;
        }
        PhoneNumberList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_PHONENUMBER;
        };
        PhoneNumberList.itemType = DataTypes.PhoneNumber;
        return PhoneNumberList;
    }(BasicTypeList));
    exports.PhoneNumberList = PhoneNumberList;
    var BooleanList = (function (_super) {
        tslib_1.__extends(BooleanList, _super);
        function BooleanList(defaults) {
            return _super.call(this, defaults) || this;
        }
        BooleanList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_BOOLEAN;
        };
        BooleanList.itemType = DataTypes.Boolean;
        return BooleanList;
    }(BasicTypeList));
    exports.BooleanList = BooleanList;
    var BinaryDataList = (function (_super) {
        tslib_1.__extends(BinaryDataList, _super);
        function BinaryDataList(defaults) {
            return _super.call(this, defaults) || this;
        }
        BinaryDataList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_BINARYDATA;
        };
        BinaryDataList.itemType = DataTypes.BinaryData;
        return BinaryDataList;
    }(BasicTypeList));
    exports.BinaryDataList = BinaryDataList;
    var TextList = (function (_super) {
        tslib_1.__extends(TextList, _super);
        function TextList(defaults) {
            return _super.call(this, defaults) || this;
        }
        TextList.getTypeDefaultValue = function () {
            return Constants.DEFAULT_TEXT;
        };
        TextList.itemType = DataTypes.Text;
        return TextList;
    }(BasicTypeList));
    exports.TextList = TextList;
    var BasicVariableHolder = (function () {
        function BasicVariableHolder(defaultValue) {
            this.varValue = defaultValue;
        }
        Object.defineProperty(BasicVariableHolder.prototype, "value", {
            get: function () {
                return this.varValue;
            },
            set: function (value) {
                this.setValue(value);
            },
            enumerable: false,
            configurable: true
        });
        BasicVariableHolder.prototype.setValue = function (value) {
            this.varValue = value;
        };
        return BasicVariableHolder;
    }());
    exports.BasicVariableHolder = BasicVariableHolder;
    var VariableHolder = (function (_super) {
        tslib_1.__extends(VariableHolder, _super);
        function VariableHolder(defaultValue) {
            return _super.call(this, defaultValue) || this;
        }
        VariableHolder.prototype.setValue = function (value) {
            _super.prototype.setValue.call(this, value ? value.clone() : value);
        };
        return VariableHolder;
    }(BasicVariableHolder));
    exports.VariableHolder = VariableHolder;
    function RecordWithStaticConstructor() {
        return function (target) {
            var asAny = target;
            if (asAny.init !== undefined) {
                asAny.init();
            }
        };
    }
    exports.RecordWithStaticConstructor = RecordWithStaticConstructor;
    var JSONSerializeOutputType = (function (_super) {
        tslib_1.__extends(JSONSerializeOutputType, _super);
        function JSONSerializeOutputType(defaults, cache) {
            return _super.call(this, defaults, cache) || this;
        }
        JSONSerializeOutputType.attributesToDeclare = function () {
            return [
                this.attr("JSON", "jSONOut", "jSONOut", true, true, DataTypes.Text, function () {
                    return defaultForType(DataTypes.Text);
                }),
            ].concat(_super.attributesToDeclare.call(this));
        };
        JSONSerializeOutputType = tslib_1.__decorate([
            RecordWithStaticConstructor()
        ], JSONSerializeOutputType);
        return JSONSerializeOutputType;
    }(GenericRecord));
    exports.JSONSerializeOutputType = JSONSerializeOutputType;
    var ErrorHandlerOutputType = (function (_super) {
        tslib_1.__extends(ErrorHandlerOutputType, _super);
        function ErrorHandlerOutputType(defaults, cache) {
            return _super.call(this, defaults, cache) || this;
        }
        ErrorHandlerOutputType.attributesToDeclare = function () {
            return [
                this.attr("ExceptionMessage", "exceptionMessageAttr", "exceptionMessageAttr", true, true, DataTypes.Text, function () {
                    return defaultForType(DataTypes.Text);
                }),
            ].concat(_super.attributesToDeclare.call(this));
        };
        ErrorHandlerOutputType = tslib_1.__decorate([
            RecordWithStaticConstructor()
        ], ErrorHandlerOutputType);
        return ErrorHandlerOutputType;
    }(GenericRecord));
    exports.ErrorHandlerOutputType = ErrorHandlerOutputType;
    var RecordTypeFactory = (function () {
        function RecordTypeFactory() {
            this.typeDefinitions = new Map();
            this.typeCache = new Map();
        }
        RecordTypeFactory.prototype.isTypeRegistered = function (key) {
            return this.typeDefinitions.get(key) !== undefined;
        };
        RecordTypeFactory.prototype.registerTypeDefinition = function (key, typeDefinition) {
            this.typeDefinitions.set(key, typeDefinition);
        };
        RecordTypeFactory.prototype.getType = function (key) {
            var type = this.typeCache.get(key);
            if (type) {
                return type;
            }
            var attrs = this.typeDefinitions.get(key);
            if (!attrs) {
                throw new TypeError("Type ".concat(key, " was not registered"));
            }
            var RecordType = (function (_super) {
                tslib_1.__extends(RecordType, _super);
                function RecordType(defaults, cache) {
                    return _super.call(this, defaults, cache) || this;
                }
                RecordType.attributesToDeclare = function () {
                    var _this = this;
                    return attrs
                        .map(function (attrInfo) {
                        return _this.attr(attrInfo.name, attrInfo.attrName, attrInfo.nameForJson || attrInfo.attrName, attrInfo.mandatory === undefined ? false : attrInfo.mandatory, attrInfo.ignoreForServer === undefined ? true : attrInfo.ignoreForServer, attrInfo.dataType, attrInfo.defaultValue, attrInfo.optimizeList === undefined ? true : attrInfo.optimizeList, attrInfo.complexType);
                    })
                        .concat(_super.attributesToDeclare.call(this));
                };
                RecordType = tslib_1.__decorate([
                    RecordWithStaticConstructor()
                ], RecordType);
                return RecordType;
            }(GenericRecord));
            this.typeCache.set(key, RecordType);
            return RecordType;
        };
        return RecordTypeFactory;
    }());
    exports.RecordTypeFactory = RecordTypeFactory;
    var TypeKeyedTypeFactory = (function (_super) {
        tslib_1.__extends(TypeKeyedTypeFactory, _super);
        function TypeKeyedTypeFactory(mainAttributeName, mainAttributeAttrName, additionalAttributes) {
            var _this = _super.call(this) || this;
            _this.mainAttributeName = mainAttributeName;
            _this.mainAttributeAttrName = mainAttributeAttrName;
            _this.additionalAttributes = additionalAttributes;
            return _this;
        }
        TypeKeyedTypeFactory.prototype.registerTypeDefinition = function (key, typeDefinition) {
            throw new Error("Invalid operation");
        };
        TypeKeyedTypeFactory.prototype.createMainAttributeInfo = function (type) {
            return {
                name: this.mainAttributeName,
                attrName: this.mainAttributeAttrName,
                mandatory: true,
                dataType: this.getDataType(type),
                defaultValue: this.getDefaultValue(type),
                complexType: this.getComplexType(type),
            };
        };
        TypeKeyedTypeFactory.prototype.registerTypeIfNeeded = function (type) {
            if (!this.isTypeRegistered(type)) {
                var attrs = [this.createMainAttributeInfo(type)];
                if (this.additionalAttributes) {
                    attrs = attrs.concat(this.additionalAttributes);
                }
                _super.prototype.registerTypeDefinition.call(this, type, attrs);
            }
        };
        TypeKeyedTypeFactory.prototype.getType = function (key) {
            this.registerTypeIfNeeded(key);
            return _super.prototype.getType.call(this, key);
        };
        return TypeKeyedTypeFactory;
    }(RecordTypeFactory));
    exports.TypeKeyedTypeFactory = TypeKeyedTypeFactory;
    var BasicTypeKeyedTypeFactory = (function (_super) {
        tslib_1.__extends(BasicTypeKeyedTypeFactory, _super);
        function BasicTypeKeyedTypeFactory(mainAttributeName, mainAttributeAttrName, additionalAttributes) {
            return _super.call(this, mainAttributeName, mainAttributeAttrName, additionalAttributes) || this;
        }
        BasicTypeKeyedTypeFactory.prototype.getDataType = function (type) {
            return type;
        };
        BasicTypeKeyedTypeFactory.prototype.getDefaultValue = function (type) {
            return function () { return defaultForType(type); };
        };
        BasicTypeKeyedTypeFactory.prototype.getComplexType = function (type) {
            return;
        };
        return BasicTypeKeyedTypeFactory;
    }(TypeKeyedTypeFactory));
    exports.BasicTypeKeyedTypeFactory = BasicTypeKeyedTypeFactory;
    var ComplexTypeKeyedTypeFactory = (function (_super) {
        tslib_1.__extends(ComplexTypeKeyedTypeFactory, _super);
        function ComplexTypeKeyedTypeFactory(mainAttributeName, mainAttributeAttrName, additionalAttributes) {
            return _super.call(this, mainAttributeName, mainAttributeAttrName, additionalAttributes) || this;
        }
        ComplexTypeKeyedTypeFactory.prototype.getDataType = function (type) {
            return DataTypes.Record;
        };
        ComplexTypeKeyedTypeFactory.prototype.getDefaultValue = function (type) {
            return function () { return ImmutableBase.getData(new type()); };
        };
        ComplexTypeKeyedTypeFactory.prototype.getComplexType = function (type) {
            return type;
        };
        return ComplexTypeKeyedTypeFactory;
    }(TypeKeyedTypeFactory));
    exports.ComplexTypeKeyedTypeFactory = ComplexTypeKeyedTypeFactory;
    var TypeValidations;
    (function (TypeValidations) {
        function isDecimal(value) {
            return value && value.constructor === Decimal_1.default;
        }
        TypeValidations.isDecimal = isDecimal;
        function isBinaryData(value) {
            return value && value.value && value.value.constructor === BinaryData;
        }
        TypeValidations.isBinaryData = isBinaryData;
        function isValidDecimal(value) {
            return isDecimal(value) && !value.isNaN();
        }
        TypeValidations.isValidDecimal = isValidDecimal;
        function isWithinDecimalRange(value) {
            return (Constants.MIN_DECIMAL_VALUE.lessThanOrEqualTo(value) &&
                Constants.MAX_DECIMAL_VALUE.greaterThanOrEqualTo(value));
        }
        TypeValidations.isWithinDecimalRange = isWithinDecimalRange;
        function isText(value) {
            return typeof value === "string";
        }
        TypeValidations.isText = isText;
        function isBoolean(value) {
            return typeof value === "boolean";
        }
        TypeValidations.isBoolean = isBoolean;
        function isBasicType(value) {
            return (isText(value) ||
                isJsNumber(value) ||
                isBoolean(value) ||
                isDateTime(value) ||
                isLongInteger(value) ||
                isDecimal(value));
        }
        TypeValidations.isBasicType = isBasicType;
        function isValidInteger(value) {
            return isValidJsNumber(value) && value % 1 === 0;
        }
        TypeValidations.isValidInteger = isValidInteger;
        function isValidJsNumber(value) {
            return isJsNumber(value) && !isNaN(value);
        }
        TypeValidations.isValidJsNumber = isValidJsNumber;
        function isJsNumber(value) {
            return typeof value === "number";
        }
        TypeValidations.isJsNumber = isJsNumber;
        function isWithinIntegerRange(value) {
            return value >= Constants.MIN_INTEGER_VALUE && value <= Constants.MAX_INTEGER_VALUE;
        }
        TypeValidations.isWithinIntegerRange = isWithinIntegerRange;
        function isValidLongInteger(value) {
            return isLongInteger(value);
        }
        TypeValidations.isValidLongInteger = isValidLongInteger;
        function isLongInteger(value) {
            return value && value.constructor === LongInteger_1.default;
        }
        TypeValidations.isLongInteger = isLongInteger;
        function isValidDate(value) {
            return (isValidDateTime(value) &&
                value.hours === Constants.DEFAULT_DATE.hours &&
                value.minutes === Constants.DEFAULT_DATE.minutes &&
                value.seconds === Constants.DEFAULT_DATE.seconds);
        }
        TypeValidations.isValidDate = isValidDate;
        function isValidTime(value) {
            return (isValidDateTime(value) &&
                value.year === Constants.DEFAULT_TIME.year &&
                value.month === Constants.DEFAULT_TIME.month &&
                value.day === Constants.DEFAULT_TIME.day);
        }
        TypeValidations.isValidTime = isValidTime;
        function isDateTime(value) {
            return value instanceof DateTime;
        }
        TypeValidations.isDateTime = isDateTime;
        function isValidDateTime(value) {
            return isDateTime(value) && !isNaN(value.getTime());
        }
        TypeValidations.isValidDateTime = isValidDateTime;
        function isJsDate(value) {
            return value instanceof Date || Object.prototype.toString.call(value) === "[object Date]";
        }
        TypeValidations.isJsDate = isJsDate;
        function isValidJsDate(value) {
            return isJsDate(value) && !isNaN(value.getTime());
        }
        TypeValidations.isValidJsDate = isValidJsDate;
        function hasBinaryDataInterface(value) {
            return !!value && (value.content !== undefined || value.url !== undefined);
        }
        TypeValidations.hasBinaryDataInterface = hasBinaryDataInterface;
        var MAX_SAFE_NUMBER = 9007199254740991;
        var MIN_SAFE_NUMBER = -9007199254740991;
        function ensureNumberInsideBounds(value) {
            var maxOrMin = "";
            var maxOrMinValue = "";
            if (value.greaterThan(MAX_SAFE_NUMBER)) {
                maxOrMin = "maximum";
                maxOrMinValue = MAX_SAFE_NUMBER.toString();
            }
            else if (value.lessThan(MIN_SAFE_NUMBER)) {
                maxOrMin = "minimum";
                maxOrMinValue = MIN_SAFE_NUMBER.toString();
            }
            else {
                return;
            }
            var NUMBER_EXCEEDS_MESSAGE = "Unable to convert ".concat(value.toString(), " to the Javascript Number type since exceeds the ").concat(maxOrMin, " value allowed which is ").concat(maxOrMinValue, ".");
            throw new Exceptions_1.Exceptions.NumberOverflowException(NUMBER_EXCEEDS_MESSAGE);
        }
        TypeValidations.ensureNumberInsideBounds = ensureNumberInsideBounds;
        function ensureNumberPrecision(value) {
            var MAX_PRECISION = 16;
            if (value.decimalPlaces() > MAX_PRECISION) {
                var NUMBER_PRECISION_EXCEEDS_MESSAGE = "Unable to convert ".concat(value.toString(), " to the Javascript Number type because it will lead to precision loss. The maximum safe number of digits after the decimal point is ").concat(MAX_PRECISION, ".");
                throw new Exceptions_1.Exceptions.NumberOverflowException(NUMBER_PRECISION_EXCEEDS_MESSAGE);
            }
        }
        TypeValidations.ensureNumberPrecision = ensureNumberPrecision;
        var RangeBoundaries = (function () {
            function RangeBoundaries() {
            }
            Object.defineProperty(RangeBoundaries, "None", {
                get: function () {
                    return "";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RangeBoundaries, "Minimum", {
                get: function () {
                    return "minimum";
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(RangeBoundaries, "Maximum", {
                get: function () {
                    return "maximum";
                },
                enumerable: false,
                configurable: true
            });
            return RangeBoundaries;
        }());
        function makeBasicTypeExceedsLimitMessage(value, type, limitHit, limitValue) {
            return "Unable to convert ".concat(value, " to the ").concat(type, " type since it exceeds the ").concat(limitHit, " value allowed which is ").concat(limitValue, ".");
        }
        function ensureNumericPlatformTypeInsideBounds(value, min, max, type) {
            var limitHit = RangeBoundaries.None;
            var limitValue = "";
            var minNumber = Math.max(min, MIN_SAFE_NUMBER);
            var maxNumber = Math.min(max, MAX_SAFE_NUMBER);
            if (value < minNumber) {
                limitHit = RangeBoundaries.Minimum;
                limitValue = minNumber.toString();
            }
            else if (value > maxNumber) {
                limitHit = RangeBoundaries.Maximum;
                limitValue = maxNumber.toString();
            }
            else {
                return null;
            }
            throw new Exceptions_1.Exceptions.NumberOverflowException(makeBasicTypeExceedsLimitMessage(value.toString(), type, limitHit, limitValue));
        }
        function ensureIntegerInsideBounds(value) {
            ensureNumericPlatformTypeInsideBounds(value, Constants.MIN_INTEGER_VALUE, Constants.MAX_INTEGER_VALUE, "Integer");
        }
        TypeValidations.ensureIntegerInsideBounds = ensureIntegerInsideBounds;
        function ensureLongIntegerInsideBounds(value) {
            ensureNumericPlatformTypeInsideBounds(value, Constants.MIN_LONGINTEGER_VALUE.toNumber(), Constants.MAX_LONGINTEGER_VALUE.toNumber(), "Long Integer");
        }
        TypeValidations.ensureLongIntegerInsideBounds = ensureLongIntegerInsideBounds;
        function ensureDecimalInsideBounds(value) {
            ensureNumericPlatformTypeInsideBounds(value, Constants.MIN_DECIMAL_VALUE.toNumber(), Constants.MAX_DECIMAL_VALUE.toNumber(), "Decimal");
        }
        TypeValidations.ensureDecimalInsideBounds = ensureDecimalInsideBounds;
    })(TypeValidations || (exports.TypeValidations = TypeValidations = {}));
});
//# sourceMappingURL=DataTypes.js.map;
